export default "__VITE_ASSET__DlPxrrwg__$_?nuxt_component=async&nuxt_component_name=SvgoPartnerItachu&nuxt_component_export=default__"